import { ModelType } from '../../common/enums.js';
import { HorizontalM2MSubscriptions } from '../HorizontalSubscriptionCard/HorizontalM2MSubscriptions';
import { HorizontalMobileBroadbandNOESubscriptions } from '../HorizontalSubscriptionCard/HorizontalMobileBroadbandNOESubscriptions';
import { HorizontalVoiceSubscriptions } from '../HorizontalSubscriptionCard/HorizontalVoiceSubscriptions';
import { getAnalyticsListName } from '../HorizontalSubscriptionCard/subscriptionCardsAnalyticsUtils.js';
import type { OfferProductMapType } from './OrderSubscriptionSelectionUtils';
import type { OfferPerGroup } from './subscriptionProductCardUtils';
import type { ModelType as OnlineModelType } from '../../common/enums.js';
import type {
  SubCardWithAnalyticsV4Props,
  SubCardWithImpressionProps,
} from '../HorizontalSubscriptionCard/subscriptionCardsAnalyticsUtils.js';
import type { SubscriptionCardWithModel } from '../HorizontalSubscriptionCard/types';
import type { MobileBroadbandSubCardProps, SubscriptionCardProps } from '../SubscriptionCard/SubscriptionCard.js';

export interface SubscriptionCardsByModelTypeProps {
  subscriptionCards: (SubscriptionCardProps | SubCardWithAnalyticsV4Props | SubCardWithImpressionProps)[];
  onlineModelType: OnlineModelType;
  isChangeOffer: true;
  offerAndFeeMap?: OfferProductMapType[];
  onSelectOffer: (guid: string, name: string) => void;
  selectedOffersPerGroup?: OfferPerGroup[];
  eventOrigin: string;
}

export const SubscriptionCardsByModelType = ({
  subscriptionCards,
  onlineModelType,
  isChangeOffer,
  offerAndFeeMap,
  onSelectOffer,
  selectedOffersPerGroup,
  eventOrigin,
}: SubscriptionCardsByModelTypeProps) => {
  const analyticsListName = `${eventOrigin} ${getAnalyticsListName(onlineModelType)}`;

  switch (onlineModelType) {
    case ModelType.YrityspuheUusi:
      return (
        <HorizontalVoiceSubscriptions
          subscriptionCards={subscriptionCards as SubscriptionCardWithModel[]}
          wide={true}
          analyticsListName={analyticsListName}
          isChangeOffer={isChangeOffer}
          offerAndFeeMap={offerAndFeeMap}
          onSelectOffer={onSelectOffer}
          selectedOfferPerGroup={selectedOffersPerGroup?.reduce(
            (acc: Record<string, string>, cur) => ({ ...acc, [cur.groupName]: cur.offerCode }),
            {}
          )}
        />
      );
    case ModelType.MobileBroadband:
      return (
        <HorizontalMobileBroadbandNOESubscriptions
          subscriptionCards={subscriptionCards as MobileBroadbandSubCardProps[]}
          isChangeOffer={isChangeOffer}
          offerAndFeeMap={offerAndFeeMap}
        />
      );
    case ModelType.MobileM2M:
      return (
        <HorizontalM2MSubscriptions
          subscriptionCards={subscriptionCards as SubscriptionCardWithModel[]}
          wide={true}
          analyticsListName={analyticsListName}
          isChangeOffer={isChangeOffer}
          offerAndFeeMap={offerAndFeeMap}
        />
      );

    default:
      // For any other model types, use VoiceSubscriptions as default
      return (
        <HorizontalVoiceSubscriptions
          subscriptionCards={subscriptionCards as SubscriptionCardWithModel[]}
          wide={true}
          analyticsListName={analyticsListName}
          isChangeOffer={isChangeOffer}
          offerAndFeeMap={offerAndFeeMap}
        />
      );
  }
};
